export default "__VITE_ASSET__COl9yuib__"